import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import './HeroHome.css';
import NavHome from '../NavHome/NavHome';
import img1 from '../../../Images/nerdland.jpg';
import { Link } from 'react-router-dom';

const HeroHome = () => {
  return (
    <div className='hero-home'>
      <NavHome />
      <div className='hero-home-content'>
        <div className='hero-home-wording'>
          <h1 className='hero-home-heading'>
            Hire, pay, and manage your team all in one place.
          </h1>
          <p className='hero-home-subtext'>
            Put the joy back in running your business. Work faster and reduce errors with automated payroll, HR, and more.
          </p>
          <div className='hero-home-cta'>
            <motion.button
              className='cta-button first-btn'
              whileHover={{ scale: 1.05 }} // Scale on hover
              whileTap={{ scale: 0.95 }}  // Scale down on tap
              transition={{ duration: 0.2 }}
            >
              
              <Link style={{color: "white", textDecoration : "none"}} className='link' to="/login">How Nerday Works</Link>
            </motion.button>
            <motion.button
              className='cta-button sec-btn'
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.2 }}
            >
                 <Link style={{color: "rgb(58, 140, 140)", textDecoration : "none"}} className='link' to="/login"> Create Account</Link>
             
            </motion.button>
          </div>
          <p className='extra-wording'>
            Already using Nerday? <Link className='link' to="/login">Sign in</Link>
          </p>
        </div>
        <div className='hero-home-image'>
          <img src={img1} alt="Landing" />
        </div>
      </div>
    </div>
  );
};

export default HeroHome;


// // HeroHome






// import React, {useState} from 'react';

// import "./HeroHome.css"
// import NavHome from '../NavHome/NavHome';
// import img1 from "../../../Images/Landing.jpg"
// import { Link } from 'react-router-dom';



// function HeroHome() { 
 

//   return <>     
    
//             <div className='HeroHomeCover'>

//                 <NavHome/>

//                  <div className='HeroHomeContent'>  

//                             <div className='HeroHomeWording'>   
//                                 <div>

                              

//                                     <div className='HeroHomeHeading'>

//                                         <h1>
//                                               Hire, pay, and manage your team all in one place.
//                                         </h1>

//                                     </div>
//                                     <div className='HeroHomeSubtext'>

//                                             <p>Put the joy back in running your business. Work faster and reduce errors with automated payroll, HR, and more.</p>

//                                     </div>

//                                      <div className='HeroHomeCTA'>

//                                         <button className='firstBtn'>How Nerday works</button>
//                                         <button className='secBtn'>Create account</button>

//                                     </div>
//                                     <div className='extraWording'>

//                                             <p>Already using Nerday? <Link  className="Links" to={"/"}>Sign in</Link></p>

//                                     </div>
//                                 </div>

//                             </div>
//                             <div className='HeroHomeImage'>

//                                   <img src={img1} />

//                             </div>
                           

//                  </div>

           
                    
//             </div>
   

  
//   </>
  
//   ;
// }

// export default HeroHome;